
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('listing');

export default {
  name: 'ListingView',
  props: {
    footerData: {
      type: Object,
      default() {
        return {};
      },
    },
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      },
    },
    itemsCount: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default() { return []; },
    },
    perPage: {
      type: Number,
      default: 36,
    },
    header: {
      type: String,
      default: 'bed',
    },
    attrs: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  jsonld() {
    const graph = [];
    const products = (this.items || []).map((item, index) => ({
      '@type': 'ListItem',
      image: item.images?.mainImage?.src,
      url: item.url,
      name: item.name,
      position: index + 1,
    }));
    graph.push({
      '@type': 'ItemList',
      numberOfItems: this.itemsCount,
      name: this.header,
      description: (this.footerData?.seoData?.content || '').replace(/<[^>]+>/g, ' '),
      itemListElement: products,
    });
    const breadcrumbs = (this.breadcrumbs || []).map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: {
        '@id': item.url,
      },
    }));
    if (breadcrumbs.length) {
      graph.push({
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs,
      });
    }
    const filters = (this.footerData?.filters || []).map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.url,
        name: item.label,
      },
    }));
    if (filters.length) {
      graph.push({
        '@type': 'ItemList',
        name: 'Popular Filters',
        itemListElement: filters,
      });
    }
    const faq = (this.footerData?.faq || []).map((item) => ({
      '@type': 'Question',
      name: item.header,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.products
          ? item.products.map((p) => `${p.name} - $${p.price?.finalPrice}`).join('. ')
          : (item.content || '').replace(/<[^>]+>/g, ' '),
      },
    }));
    if (faq.length) {
      graph.push({
        '@type': 'FAQPage',
        mainEntity: faq,
      });
    }
    return {
      '@context': 'https://schema.org',
      '@graph': graph,
    };
  },
  computed: {
    ...mapState(['searchParams']),
    isSearchParams() {
      let copy = this.searchParams || {};
      if (this.attrs.additionalData?.isVirtual) {
        delete copy.facet;
        return Boolean(Object.keys(copy).length);
      }
      if (copy.facet) {
        copy = { ...copy, ...copy.facet };
        delete copy.facet;
      }
      return Boolean(Object.keys(copy).length);
    },
    isVirtual() {
      return this.attrs.additionalData?.isVirtual;
    },
    /**
     * Computes the status code based on the conditions:
     * - Returns 1 if `this.isVirtual` is true.
     * - Returns 2 if `this.isSearchParams` is true.
     * - Returns 0 otherwise.
     * @returns {number} The status code.
     */
    listStatusCode() {
      if (this.isVirtual) {
        return 2;
      }
      if (this.isSearchParams) {
        return 1;
      }
      return 0;
    },
    getTitle() {
      return this.listStatusCode > 0 && this.breadcrumbs.length > this.listStatusCode
        ? this.breadcrumbs[this.breadcrumbs.length - this.listStatusCode].name
        : this.header;
    },
  },
};
